"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargerControlActiveTransactionsSerialization = void 0;
const ChargingTransactionSerialization_1 = require("./ChargingTransactionSerialization");
class ChargerControlActiveTransactionsSerialization {
    static serialize(entity) {
        const copy = { ...entity };
        copy.transactions = entity.transactions?.map((field) => field
            ? JSON.parse(ChargingTransactionSerialization_1.ChargingTransactionSerialization.serialize(field))
            : undefined);
        return JSON.stringify(copy);
    }
    static deserialize(msg) {
        const entity = JSON.parse(msg);
        const copy = { ...entity };
        copy.transactions = entity.transactions?.map((field) => field
            ? ChargingTransactionSerialization_1.ChargingTransactionSerialization.deserialize(JSON.stringify(field))
            : undefined);
        return copy;
    }
}
exports.ChargerControlActiveTransactionsSerialization = ChargerControlActiveTransactionsSerialization;
